//@flow
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import Alert from "../components/alert";

const InvoiceServerRequest = function() {
  const {
    quantity,
    accounting_contact_email,
    accounting_contact_name,
    invitation_administrator_email
  } = this.state;

  axios
    .post("/school_admin/invoices", {
      invoice: {
        quantity: quantity,
        accounting_contact_name: accounting_contact_name,
        accounting_contact_email: accounting_contact_email,
        invitation_administrator_email: invitation_administrator_email,
      }
    })
    .then(successHandler.bind(this))
    .catch(errorHandler.bind(this));
};

const successHandler = function(response) {
  const { message } = response.data;

  ReactDOM.render(
    <Alert type="success" message={response.data.message} />,
    document.getElementById("alerts")
  );
};

const errorHandler = function(error) {
  const { data: { errors } } = error.response;

  const message = errors.map(error => error + ".").join(" ");

  ReactDOM.render(
    <Alert type="danger" message={message} />,
    document.getElementById("alerts")
  );

  this.setState({ disableFields: false });
};

export default InvoiceServerRequest;
